<script setup>
import {
  IconMessage,
  IconTicket,
  IconUsers,
  IconClock,
  IconXboxX,
} from "@tabler/icons-vue";

import { Skeleton } from "@/components/v4/skeleton";
import { useStore } from "vuex"; // Added useStore
// Removed useMutation, useQueryClient
import { httpClientOmni } from "@/libraries";

import moment from "moment";
import { cn } from "@/lib/utils";

import BounceLoader from "vue-spinner/src/BounceLoader.vue";

const props = defineProps({ // Added props to access type
  data: Array,
  isLoading: Boolean,
  type: {
    type: String,
    default: "notification",
  },
});

const typeMap = {
  ticket: {
    icon: IconTicket,
    color: "var(--warning-500)",
  },
  chat: {
    icon: IconMessage,
    color: "var(--info-600)",
  },
  customer: {
    icon: IconUsers,
    color: "var(--success-500)",
  },
};

const store = useStore(); // Added store instance

// Removed mutationReadNotification and mutationReadNotificationExport

const handleClick = (val) => {
  if (props.type === "notification") {
    store.dispatch("app/readNotifList", val.id); // Dispatch Vuex action
  } else if (props.type === "export") {
    store.dispatch("notification/readNotifExport", val.id); // Dispatch Vuex action
    // The download will be handled by the <a> tag's href
  }
};
</script>

<template>
  <div class="vf-flex vf-flex-col vf-gap-2 vf-w-full">
    <template v-if="isLoading">
      <Skeleton
        v-for="s in 7"
        :key="s"
        class="vf-w-full vf-h-[75px] vf-rounded-md"
      />
    </template>
    <template v-else>
      <component
        :is="props.type === 'export' && val.status === 'done' ? 'a' : 'div'"
        :href="props.type === 'export' && val.status === 'done' ? val.url : null"
        :target="props.type === 'export' && val.status === 'done' ? '_blank' : null"
        role="button"
        v-for="(val, i) in data"
        :tabindex="i"
        @click="handleClick(val)"
        :class="
          cn(
            'vf-flex vf-gap-x-2 !vf-w-full vf-items-start vf-p-2 hover:vf-bg-primary-50 t vf-cursor-pointer vf-rounded-md',
            (props.type === 'notification' ? !val.read : !val.seen != 0) &&
              'vf-bg-neutral-100'
          )
        "
        :key="val.id"
      >
        <div
          class="vf-p-4 vf-bg-neutral-50 vf-rounded-md"
          v-if="props.type === 'notification'"
        >
          <component
            :is="typeMap[val.type]?.icon"
            size="24"
            :color="typeMap[val.type].color"
          />
        </div>
        <div class="vf-flex vf-flex-col vf-w-full">
          <div class="vf-flex vf-justify-between">
            <h6
              :class="cn('vf-text-sm', props.type === 'export' && 'vf-font-semibold')"
            >
              {{
                props.type === "notification"
                  ? truncateText(val.title, 35)
                  : val.filename
              }}
            </h6>
            <span
              v-if="props.type === 'notification'"
              class="vf-text-neutral-400 vf-text-[10px]"
              >{{ moment(val.created_at).fromNow(true) }}</span
            >
          </div>
          <p
            v-if="props.type === 'notification'"
            class="vf-text-sm vf-text-neutral-400"
          >
            {{ val.url }}
          </p>

          <span
            v-if="props.type === 'notification'"
            class="vf-capitalize"
            :style="{ color: typeMap[val.type].color }"
            >{{ val.type }}</span
          >
          <span class="vf-text-xs vf-mt-1" v-else>
            <span
              v-if="val.status === 'done'"
              class="vf-flex vf-items-center vf-gap-x-0.5 vf-text-neutral-400"
            >
              <IconClock color="var(--neutral-400)" size="14" />
              {{ moment(val.exported_at).fromNow(true) }}
            </span>
            <span
              v-else-if="val.status === 'failed'"
              class="vf-flex vf-items-center vf-gap-x-1 vf-text-red-500"
            >
              <IconXboxX color="red" size="14" />
              <span class="vf-text-[10px]">FAILED</span>
            </span>
            <span
              v-else
              class="vf-flex vf-items-center vf-gap-x-1 vf-text-neutral-400"
            >
              <BounceLoader
                :loading="true"
                color="var(--neutral-400)"
                size="14px"
              />
              <span class="vf-text-[10px]">PROCESSING</span>
            </span>
          </span>
        </div>
      </component>
    </template>
  </div>
</template>
